import { debounce } from '@mui/material/utils';
import { useLayoutEffect, useState } from 'react';

/** @typedef { import('../types/utilityTypes').Timestamp } Timestamp */

/**
 * @typedef {object} ReturnValue
 * @property {number} width
 * @property {number} height
 */

/** @type {() => ReturnValue} */
export function useWindowSize() {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const updateValues = debounce(() => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }, 200);

    window.addEventListener('resize', updateValues);
    updateValues();

    return () => {
      window.removeEventListener('resize', updateValues);
    };
  }, []);

  return {
    width,
    height,
  };
}
